import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchasePayment } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreatePurchasePaymentPayload,
    MarkPaymentPaidPayload,
    UpdatePurchasePaymentPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { useCallback, useState } from 'react'

export const usePurchasePaymentActions = () => {
    const createUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCreatePurchasePayment
    )
    const updateUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchasePayment
    )
    const payUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseMarkPurchasePaymentPaid
    )
    const cancelUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCancelPurchasePayment
    )

    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const runAction = useCallback(
        async <T>(action: () => Promise<T>, fallback: string) => {
            setLoading(true)
            setError(null)
            try {
                return await action()
            } catch (e: any) {
                console.error(e)
                setError(e?.response?.data?.message ?? fallback)
                return null
            } finally {
                setLoading(false)
            }
        },
        []
    )

    const create = useCallback(
        (processId: string, payload: CreatePurchasePaymentPayload) =>
            runAction<PurchasePayment>(
                () => createUseCase.execute(processId, payload),
                'Erro ao criar o pagamento'
            ),
        [createUseCase, runAction]
    )

    const update = useCallback(
        (
            processId: string,
            paymentId: string,
            payload: UpdatePurchasePaymentPayload
        ) =>
            runAction<PurchasePayment>(
                () => updateUseCase.execute(processId, paymentId, payload),
                'Erro ao atualizar o pagamento'
            ),
        [updateUseCase, runAction]
    )

    const markPaid = useCallback(
        (processId: string, paymentId: string, payload: MarkPaymentPaidPayload) =>
            runAction<PurchasePayment>(
                () => payUseCase.execute(processId, paymentId, payload),
                'Erro ao dar baixa no pagamento'
            ),
        [payUseCase, runAction]
    )

    const cancel = useCallback(
        (processId: string, paymentId: string) =>
            runAction<PurchasePayment>(
                () => cancelUseCase.execute(processId, paymentId),
                'Erro ao cancelar o pagamento'
            ),
        [cancelUseCase, runAction]
    )

    return { create, update, markPaid, cancel, loading, error }
}
